<template>
  <div v-if="service && !service.flags?.surcharge">
    <div class="garage-price-list-element">
      <NuxtImg
        v-if="popularCategory"
        :src="service.flags?.virtual ? `/_nuxt/repair-categories/${service.id}.svg` : `/_nuxt/${service.autobooking?.categoryId}.svg`"
        height="28px"
        width="28px"
        alt="Popularna usługa"
      />
      <div
        @click="toggleModal"
        class="garage-price-list-element__service"
        :class="{ 'garage-price-list-element__service--border': !popularCategory }"
      >
        <div class="garage-price-list-element__wrapper">
          <p class="garage-price-list-element__service-name">{{ capitalizeFirstLetter(service.name) }}</p>

          <div
            v-if="service.description"
            class="garage-price-list-element__service-description"
          >
            <p>{{ description }}</p>
          </div>

          <template v-if="service.price?.priceFrom">
            <div class="garage-price-list-element__price-line">
              <div
                v-if="service.price.priceFrom === service.price.priceTo"
                class="garage-price-list-element__service-price"
              >
                {{ service.price.priceFrom || 0 }} zł <i class="i-info"></i>
              </div>
              <div
                v-else-if="service.price.priceFrom && service.price.priceTo"
                class="garage-price-list-element__service-price"
              >
                od {{ service.price.priceFrom || 0 }} do {{ service.price.priceTo || 0 }} zł <i class="i-info"></i>
              </div>
              <div
                v-else
                class="garage-price-list-element__service-price"
              >
                od {{ service.price.priceFrom || 0 }} zł <i class="i-info"></i>
              </div>


              <div
                class="garage-price-list-element__button-wrapper-price-line"
                :class="{ 'garage-price-list-element__button-wrapper-price-line--price': !!service.price.priceFrom }"
                v-if="premium && onlineBooking"
              >
                <NuxtLink
                  class="garage-price-list-element__link"
                  :to="nuxtLinkTo(service)"
                >
                  <DmButton
                    class="garage-price-list-element__button"
                    title="Umów"
                    @click.stop
                    tertiary
                  />
                </NuxtLink>
              </div>
            </div>
          </template>
        </div>

        <div
          class="garage-price-list-element__button-wrapper"
          :class="{ 'garage-price-list-element__button-wrapper--no-price': !service.price?.priceFrom }"
        >
          <template v-if="service.price?.priceFrom">
            <div
              v-if="service.price.priceFrom === service.price.priceTo"
              class="garage-price-list-element__service-price"
            >
              {{ service.price.priceFrom || 0 }} zł <i class="i-info"></i>
            </div>
            <div
              v-else-if="service.price.priceFrom && service.price.priceTo"
              class="garage-price-list-element__service-price"
            >
              od {{ service.price.priceFrom || 0 }} do {{ service.price.priceTo || 0 }} zł <i class="i-info"></i>
            </div>
            <div
              v-else
              class="garage-price-list-element__service-price"
            >
              od {{ service.price.priceFrom || 0 }} zł <i class="i-info"></i>
            </div>
          </template>

          <NuxtLink
            class="garage-price-list-element__link"
            :to="nuxtLinkTo(service)"
            @click.stop
            v-if="premium && onlineBooking"
          >
            <DmButton
              class="garage-price-list-element__button"
              title="Umów"
              tertiary
            />
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { DmButton, } from '@dobrymechanik/vue-ui-v2';
import type { PriceElementView } from '~/api/docs/app';
import { capitalizeFirstLetter } from '~/helpers/helpers';

interface IProps {
  service: PriceElementView;
  popularCategory: boolean;
  premium?: boolean;
  onlineBooking?: boolean;
}

interface IEmits {
  (name: 'show-service-details', value: PriceElementView): void;
}

// data
const shortDescriptionLength: number = 42;
const shortDescriptionModalLength: number = 64;
const modals = ref({
  details: false
});
const expanded: Ref<boolean> = ref(false);

// emits 
const emits = defineEmits<IEmits>();

// props
const props = defineProps<IProps>();

// use 
const route = useRoute();

// computed
const description = computed(() => {
  return props.service.description?.substring(0, shortDescriptionLength) + '...';
});

const modalDescription = computed(() => {
  return !expanded.value && props.service.description?.length || 0 > shortDescriptionModalLength
    ? props.service.description?.substring(0, shortDescriptionModalLength) + '...'
    : props.service.description;
});

// methods
const nuxtLinkTo = (service: PriceElementView) => {
  if (service.flags?.virtual) {
    return route.path.includes('/services') ? `${route.path}?other-reason=true&service-id=${props.service.id}` : `${route.path}/services?other-reason=true&service-id=${props.service.id}`;
  }

  return route.meta.layout === 'modal'
    ? `${route.path}/${service.autobooking?.serviceId}?repairDescription=${service.name}`
    : `${route.path}/services/${service.autobooking?.serviceId}?repairDescription=${service.name}`;
};

const toggleModal = () => {
  if (!props.service.price?.priceFrom) return;
  emits('show-service-details', props.service);
}

</script>

<style lang="scss">
@import url('assets/styles/components/garage-price-element.scss');
</style>